import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Button, { ButtonTypes } from 'components/common/button';
import ChatIconOutline from 'components/lib/icons/chat_icon_outline';
import connect from 'components/lib/connect';
import CustomerView from 'models/location/customer_view';
import DismissNotification from 'actions/notification/dismiss_notification';
import { getTextForContent } from 'models/conversation_item';
import IconClasses from 'components/lib/icon_classes';
import NavigateToConversation from 'actions/conversation/navigate_to_conversation';
import Notification from './notification';
import ConversationItemType from 'models/conversation_item_type';

function IncomingConcurrentMessageNotification({
  customerName,
  isNotificationForCurrentConversation,
  messageText,
  notificationId,
  onCancel,
  onReply,
  type,
}) {
  if (!notificationId || isNotificationForCurrentConversation) {
    return null;
  }
  return (
    <Notification contentClasses="incomingConcurrentMessageNotification" notificationId={notificationId}>
      <div className="conversationNotification-topic">
        {renderIcon()}
        <div className="conversationNotification-notificationType">Reply</div>
        <div className="conversationNotification-divider" />
        <div className="conversationNotification-topic-container">
          <div className="conversationNotification-topic-heading">{customerName}</div>
          <div className="conversationNotification-divider" />
          <div className="conversationNotification-topic-body">{messageText}</div>
        </div>
      </div>
      <div>
        <Button data-aid="notification-button-dismiss" contrast buttonType={ButtonTypes.TEXT} onClick={onCancel}>
          Dismiss
        </Button>
        <Button
          data-aid="notification-button-primary"
          contrast
          buttonType={ButtonTypes.PRIMARY}
          onClick={onClickPrimary}
        >
          Reply
        </Button>
      </div>
    </Notification>
  );

  function onClickPrimary(ev) {
    ev.stopPropagation();
    onReply();
  }

  function renderIcon() {
    return type === ConversationItemType.CHAT_MESSAGE ? (
      <ChatIconOutline className="conversationNotification-chat-icon" />
    ) : (
      <i className={IconClasses[type]} />
    );
  }
}

IncomingConcurrentMessageNotification.propTypes = {
  customerName: PropTypes.string,
  isNotificationForCurrentConversation: PropTypes.bool,
  messageText: PropTypes.string,
  onReply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  notificationId: PropTypes.string,
  type: PropTypes.string,
};

const IncomingConcurrentMessageNotificationContainer = connect(
  mapStateToProps,
  mapExecuteToProps
)(IncomingConcurrentMessageNotification);

function mapStateToProps(context, props) {
  let currentLocation = context.getProvider('currentLocation').get();
  let notification = props.notification;
  let conversationItem = _.get(notification, 'conversationItem');
  let type = conversationItem && conversationItem.contentType();
  if (type === ConversationItemType.CONVERSATION_MESSAGE) {
    type = _.get(conversationItem.content, 'channel');
  }

  return {
    customerName: _.get(notification, 'profile.name') || 'Customer',
    isNotificationForCurrentConversation: isNotificationForCurrentConversation(),
    messageText: getTextForContent(notification.conversationItem.toJs().content) || 'New message',
    notificationId: _.get(notification, 'id'),
    type,
  };

  function isNotificationForCurrentConversation() {
    return (
      currentLocation instanceof CustomerView && currentLocation.currentConversationId === notification.conversationId
    );
  }
}

function mapExecuteToProps(executeAction, props) {
  return {
    onReply: () => {
      executeAction(DismissNotification, props.notification.id);
      executeAction(NavigateToConversation, {
        customerId: props.notification.profile.id,
        conversationId: props.notification.conversationId,
      });
    },
    onCancel: () => executeAction(DismissNotification, props.notification.id),
  };
}

export { IncomingConcurrentMessageNotification };
export default IncomingConcurrentMessageNotificationContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/notification/incoming_concurrent_message_notification.jsx